// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_ay-0";
export var orangeButton = "_ay-1";